import comp from "./PickAttachmentModal";
export default comp;
